import React, { useEffect,useState,} from 'react';
import AxiosURL from '../../ApiService/AxiosURL';
import { ProgressBar } from 'react-bootstrap';
import DonutChart from 'react-donut-chart';
import Sidebar from '../layout/Sidebar';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Breadcrumb from './Breadcrumb';
import emitter from "./emitter";  
import './pages.css';
import {
  ResponsiveContainer,
  CartesianGrid,
  AreaChart,
  LineChart,
  BarChart,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  Line,
  Area,
  Bar,
} from "recharts";
import { Axios } from 'axios';
import { Loader } from 'rsuite';

const Dashboard=()=>
{  const  pd=40;
  let API_farmer_perfom   = "farmers/Farmers_Performance";
  let API_Pie             = "farmers/piegraph_home_data";
  let API_all_farmer      = "farmers/GetAllFarmerstatic";
  let API_women_data      = "farmers/women_farmer";
  let API_inputEffect     = "farmers/inputEffect"; 


  const [pieChart_users, setpieChart_users] = useState([]);
  const [farmerPerform, setFarmerperfom] = useState([]);
  const [inputEffects, setInputEffects] = useState([]);
  const [useAllfarmers, setAllFarmers] = useState([]);
  const [usewomenData, setWomenData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(()=>{
    fetchFarmerperfom(API_farmer_perfom);
    fetchInputEffect(API_inputEffect);
    fetchAllFarmers(API_all_farmer);
    fetchWomenData(API_women_data);
    fetchApiData_PieChart(API_Pie);
    const lister = emitter.addListener("sendFilterData",districtDataFilter)
    return ()=>lister.remove();
  },[]);
  
  const fetchWomenData = async(url) =>{
    try{
    const response = await AxiosURL.get(url)
    setWomenData(response.data.data)
    }catch(error){
      console.log(error);
    }
  }

  const fetchApiData_PieChart= async(url)=>{
    try{
      const response = await AxiosURL.get(url)
      setpieChart_users(response.data.data);
    }catch(error){
      console.log(error);      
    }
  };
 
  const fetchInputEffect = async(url)=>{
    try{
      setIsLoading(true)
    const res = await AxiosURL.get(url)
    setInputEffects(res.data.data);
    setIsLoading(false)
    }catch(error){
      console.log(error);
    }
  }

  const fetchFarmerperfom = async (url)=>{
    try{
      setIsLoading(true)
        const response = await AxiosURL.get(url)
        setFarmerperfom(response.data.data);
      setIsLoading(false)
    }catch(error){
      console.log(error);
    }
  }

  const fetchAllFarmers = async (url)=>{
    try{
        const response = await AxiosURL.get(url);
        setAllFarmers(response.data.data)
        // console.log(response.data.data);
    }catch(error){
      console.log(error);
    }
  }
   // Ganesh was written the code
   const districtDataFilter = async (distData)=>{
    var villData = distData['village'];
    if(distData['district'])
    {
      if(distData.district == 'select')
      {
        fetchFarmerperfom(API_farmer_perfom);
        fetchInputEffect(API_inputEffect);
        fetchAllFarmers(API_all_farmer);
        fetchWomenData(API_women_data);
        fetchApiData_PieChart(API_Pie);

      }else{
        setIsLoading(true);
        const response = await AxiosURL.get(API_women_data,{ params:distData})
        setWomenData(response.data.data);
        getFarmerPerform(distData);
        getPiaChartData(distData);
        getInputEffect(distData);
        getAllFarmers(distData);
        setIsLoading(false);
      }
    }
    else
    {
      if(distData.village == 'select')
      {
        fetchWomenData(API_women_data);
        fetchApiData_PieChart(API_Pie);
        fetchFarmerperfom(API_farmer_perfom);        
      }else{
        setIsLoading(true);
        const response = await AxiosURL.get(API_women_data,{ params:distData,"village":villData})
        setWomenData(response.data.data)
        getPiaChartData(distData);
        setIsLoading(false);
      }
    }
  }
  const getPiaChartData = async (distData)=>{
    const pieChartResponse = await AxiosURL.get(API_Pie,{ params:distData})
    setpieChart_users(pieChartResponse.data.data);
  }

  const getFarmerPerform = async(distData)=>{
    const farmerPerformResponse = await AxiosURL.get(API_farmer_perfom,{params:distData});
    setIsLoading(true)
      setFarmerperfom(farmerPerformResponse.data.data);
    setIsLoading(false)
  }

  const getInputEffect = async (distData)=>{
    setIsLoading(true)
    const inputEffectResponse = await AxiosURL.get(API_inputEffect,{params:distData});
    setInputEffects(inputEffectResponse.data.data);
    setIsLoading(false)
  }

  const getAllFarmers = async(distData)=>{
    const allfarmersResponse = await AxiosURL.get(API_all_farmer,{params:distData});
    setAllFarmers(allfarmersResponse.data.data);
  }
  return (
  <div className='wrapper card-body'>
    <Sidebar />
    <div className='main '>
      <Header />
      <main className='content'>
      <div className='container-fluid p-0'>

            <section className='row '>

              <div className='row'>
                <div className='col col-md-8'>
                  <div className='card graphCard'>
                    <div className='card-body'>
                      <b>All farmers year wise categorised in internal , external and total farmers</b>
                    <ResponsiveContainer width="95%" height={400}>
                    <BarChart  data={useAllfarmers} barSize={45} >
                        <CartesianGrid />
                  
                        <Tooltip cursor={false}/>
                        <Legend/>
                        <XAxis dataKey="year"/>
                        <YAxis />
                        <Bar dataKey="internal_farmers" stackId="a" fill="#00BB00" stroke="" unit=" farmers" />
                        <Bar dataKey="external_farmers" stackId="a" fill="#FF9900" stroke="" unit=" farmers" />
                        <Bar dataKey="all_farmers" fill="#229af5" stroke="" unit=" farmers"/>
                    </BarChart>
                    </ResponsiveContainer>
                    </div>
                    
                  </div>
                </div>
                <div className='col-md-4'>
                <div className='card graphCard'>
                  <div className='card-body'>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Year</th>
                        <th scope="col" style={{ backgroundColor: '#00BB00', color:"#000000"}}>Internal</th>
                        <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>External</th>
                        <th scope="col" style={{ backgroundColor: '#229af5', color:"#000000"}}>All Farmers</th>
                      </tr>
                    </thead>
                    <tbody>
                    {useAllfarmers.map(( listValue, index ) => {
                    return (<tr key={index}>
                        <th >{listValue.year}</th>
                        <td style={{ backgroundColor: '#00BB00', color:"#000000"}}>{listValue.internal_farmers}</td>
                        <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{listValue.external_farmers}</td>
                        <td style={{ backgroundColor: '#229af5', color:"#000000"}}>{listValue.all_farmers}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                  </div>
                </div>
                </div>
              </div>
              <div className='col-12'>
                <Breadcrumb />
                </div>
              <div className='row'>
              <div className='col col-md-8'>
                  <div className='card linegraph graphCard'>
                    <div className='card-body'>
                      <b>Net income per hectare</b>
                      {isLoading ? <Loader size="md"/> : 
                    <ResponsiveContainer width="95%" height={400}>
                        <BarChart
                          width={400}
                          height={400}
                          data={inputEffects}
                          margin={{ top: 5, right: 30, left: 0, bottom: 5 }}
                          >
                          <XAxis dataKey="year" />
                          <YAxis />
                          <Tooltip cursor={true} />
                          <Legend />
                          <CartesianGrid strokeDasharray="3 3" />
                          <Bar dataKey="input_cost" fill="#229af5 "  unit=" Rs./h"/>
                          <Bar dataKey="net_income" fill="#FF9900"  unit=" Rs./h"/>
                        </BarChart> 
                    </ResponsiveContainer>
                    }
                    </div>
                  </div>
                </div>
                <div className='col-md-4'>
                <div className='card graphCard'>
                  <div className='card-body'>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Year</th>
                        <th scope="col" style={{ backgroundColor: '#00BB00', color:"#000000"}}>Input cost</th>
                        <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>Net income</th>
                      </tr>
                    </thead>
                    <tbody>
                    {inputEffects.map(( listValue, index ) => {
                    return (<tr key={index}>
                        <td >{listValue.year}</td>
                        <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{listValue.input_cost}</td>
                        <td style={{ backgroundColor: '#229af5', color:"#000000"}}>{listValue.net_income}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                  </div>
                </div>
                </div>
                </div>
                <div className='row'>
                <div className='col col-8'>
                  <div className='card graphCard'>
                    <div className='card-body'>
                      <b>Performance of all project farmers</b>
                    <ResponsiveContainer width="95%" height={400}>
                    {isLoading ? <Loader size="md"/> : 
                    <BarChart data={farmerPerform}
                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <defs>
                          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
                          </linearGradient>
                          <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
                          </linearGradient>
                        </defs>
                        <XAxis dataKey="year" />
                        <YAxis />
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip />
                        <Legend/>
                        <Bar type="monotone" dataKey="net_income" stroke="#229af5" fillOpacity={1} fill="#229af5"  unit=" Rs./h"/>
                        <Bar type="monotone" dataKey="input_cost" stroke="#00BB00" fillOpacity={1} fill="#00BB00" unit=" Rs./h" />
                        <Bar type="monotone" dataKey="Yield" stroke="#FF9900" fillOpacity={1} fill="#FF9900" unit=" kg/h" />
                        <Bar type="monotone" dataKey="Farmers" stroke="#16f5f5" fillOpacity={1} fill="#889900" unit=""/>
                      </BarChart>
                    }
                    </ResponsiveContainer>
                    </div>
                  </div>
                </div>
                <div className='col-md-4'>
                <div className='card graphCard'>
                  <div className='card-body'>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Year</th>
                        <th scope="col" style={{ backgroundColor: '#00BB00', color:"#000000"}}>Input cost</th>
                        <th scope="col" style={{ backgroundColor: '#229af5', color:"#000000"}}>Net income</th>
                        <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>Yield</th>
                        <th scope="col" style={{ backgroundColor: '#889900', color:"#000000"}}>Farmers</th>
                      </tr>
                    </thead>
                    <tbody>
                    {farmerPerform.map(( allData, index ) => {
                    return (<tr key={index}>
                        <td >{allData.year}</td>
                        <td style={{ backgroundColor: '#00BB00', color:"#000000"}}>{allData.input_cost}</td>
                        <td style={{ backgroundColor: '#229af5', color:"#000000"}}>{allData.net_income}</td>
                        <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{allData.Yield}</td>
                        <td style={{ backgroundColor: '#889900', color:"#000000"}}>{allData.Farmers}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                  </div>
                </div>
                </div>
                </div>

                <div className='row'>
                <div className='col col-md-8'>
                  <div className='card doughnut graphCard'>
                    <div className='card-body'>
                              
                    {/* graph for women performance data */}
                      <b>Performance of all women project farmers</b>
                    <ResponsiveContainer width="95%" height={400}>
                    {isLoading ? <Loader size="md"/> : 
                        <BarChart width={400} height={400} data={usewomenData}
                        margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="year" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="net_income" stroke="#229af5" fill="#229af5" unit=" Rs./h" />
                        <Bar dataKey="input_cost" stroke="#00BB00" fill="#224488" unit=" Rs./h"/>
                        <Bar dataKey="Yield" stroke="#FF9900" fill="#901231" unit=" kg/h"/>
                        <Bar dataKey="Farmers" stroke="#16f5f5"/>
                      </BarChart>
                    }
                    </ResponsiveContainer>
                {/* End graph for women performance data */}

                    </div>
                  </div>
                            
                </div>
                <div className='col-md-4'>
                <div className='card graphCard'>
                  <div className='card-body'>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Year</th>
                        <th scope="col" style={{ backgroundColor: '#00BB00', color:"#000000"}}>Input cost</th>
                        <th scope="col" style={{ backgroundColor: '#229af5', color:"#000000"}}>Net income</th>
                        <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>Yield</th>
                        <th scope="col" style={{ backgroundColor: '#889900', color:"#000000"}}>Farmers</th>
                      </tr>
                    </thead>
                    <tbody>
                    {usewomenData.map(( allData, index ) => {
                    return (<tr key={index}>
                        <td >{allData.year}</td>
                        <td style={{ backgroundColor: '#00BB00', color:"#000000"}}>{allData.input_cost}</td>
                        <td style={{ backgroundColor: '#229af5', color:"#000000"}}>{allData.net_income}</td>
                        <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{allData.Yield}</td>
                        <td style={{ backgroundColor: '#889900', color:"#000000"}}>{allData.Farmers}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                  </div>
                </div>
                </div>
              </div>
              <div className='footer'>
                <Footer />
              </div>
            </section>
          </div>
      </main>
    </div>
  </div>
    )
}
 
export default Dashboard;




